export default __webpack_public_path__ + "static/ui-time-off-request-70b911d1b10e9e1812347e512bdb83e2.png";